import logoHenry from '../img/logoHenry.svg';
import logoUNINDETEC from '../img/logoUNINDETEC.png';

const dataExperience = [
  {
    general: {
      logoCompany: logoHenry,
      nameCompany: 'Henry',
    },
    spanish: {
      nameJob: 'Asistente de enseñanza Full-Stack',
      dateJob: 'Julio 2022 - Agosto 2022',
      description: [
        '📌 Coordinar a un grupo de estudiantes para lograr la integración al grupo de estudio.',
        '📌 Orientar a los estudiantes en los primeros pasos del curso.',
        '📌 Asistir la resolución de ejercicios y promover la colaboración grupal.',
      ],
    },
    english: {
      nameJob: 'Teaching assistant Full-Stack',
      dateJob: 'July 2022 - August 2022',
      description: [
        '📌 Coordinate a group of students to achieve integration to the study group.',
        '📌 Guide students in the first steps of the course',
        '📌 Assist to solve exercises and promote group collaboration',
      ],
    },
  },
  {
    general: {
      logoCompany: logoUNINDETEC,
      nameCompany: 'Unidad de Investigación y Desarrollo Tecnológico (UNINDETEC)',
    },
    spanish: {
      nameJob: 'Desarrollador de software',
      dateJob: 'Agosto 2021 - Febrero 2022',
      description: [
        '📌 Desarrollo de componente de software para la visualización y monitoreo de información del radar TZINACAN-200.',
        '📌 Desarrollo utilizando Java y ZeroMQ.',
      ],
    },
    english: {
      nameJob: 'Software developer',
      dateJob: 'August 2022 - February 2022',
      description: [
        '📌 Development of software component for the visualization and monitoring of information from TZINACAN-200 radar',
        '📌 Development with Java and ZeroMQ.',
      ],
    },
  },
];

export default dataExperience;
